import React, { useState } from 'react';
import { Form, Button, Card, Alert, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import './ForgotPassword.scss';
import { useDispatch } from 'react-redux';
import { recoverPasswordEmail } from '../../actions/usuarioActions';


const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const dispatch = useDispatch();

    const handleSubmit = (e) => {
        e.preventDefault();
        const emailFormat = email.trim();
        dispatch(recoverPasswordEmail(emailFormat))
        setMessage('If this email is registered, you will receive a password reset link.');
    };
    return (
        <div className='bg-forgot'>
            <div className='forgot-header'></div>
            <div className="container d-flex justify-content-center align-items-center container-forgot">
                <Card className="shadow-lg card-forgot" >
                    <Card.Body className="p-4">
                        <Card.Title className="text-center mb-3 text-primary">Recuperacion de Contraseña</Card.Title>
                        <Card.Text className="text-center text-muted mb-4">
                            Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
                        </Card.Text>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="ml-2 mb-3" controlId="email">
                                <Form.Label>Correo electrónico</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FontAwesomeIcon icon={faEnvelope} />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="email"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        className="forgot-email"
                                    />
                                </InputGroup>
                            </Form.Group>
                            <Button type="submit" variant="primary" className="w-100">
                                Enviar
                            </Button>
                        </Form>
                        {message && (
                            <Alert variant="success" className="mt-3 text-center">
                                <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                                {message}
                            </Alert>
                        )}
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
};

export default ForgotPassword;